import {
  Book,
  Calendar,
  Chats,
  Exam,
  GraduationCap,
  House,
  Student,
  Trophy,
  YoutubeLogo,
} from 'phosphor-react';
import { IUserProps } from '../../interfaces/User';

export interface IMenuLink {
  title: string;
  location: string;
  icon: any;
  badge?: string;
  description?: string;
  visible: boolean;
}

const getUserName = (): string => {
  const userString = localStorage.getItem('user');
  if (!userString) return 'Seja bem-vindo!';

  try {
    const user: IUserProps = JSON.parse(userString);
    return user.first_name || `Seja bem-vindo(a) ${user.first_name}!`;
  } catch {
    return 'Seja bem-vindo(a)!';
  }
};

const menuLinks: IMenuLink[] = [
  {
    title: 'Dashboard',
    location: '/',
    icon: House,
    description: `Que bom ter você de volta, ${getUserName()}!`,
    visible: true,
  },
  {
    title: 'Todas as Aulas',
    location: '/modulos',
    icon: YoutubeLogo,
    description: 'Acesse todas as aulas disponíveis.',
    visible: true,
  },
  {
    title: 'Player',
    location: '/aulas',
    icon: YoutubeLogo,
    //description: '',
    visible: false,
  },
  {
    title: 'Plano de Estudo',
    location: '/plano-de-estudos',
    icon: Student,
    description: 'Organize seus estudos e acompanhe seu progresso.',
    visible: true,
  },
  {
    title: 'Vestibulares',
    location: '/vestibulares',
    icon: GraduationCap,
    description: 'Os principais vestibulares do Brasil.',
    visible: true,
  },
  {
    title: 'E-books',
    location: '/ebooks',
    icon: Book,
    description: 'Acesse todos os materiais disponíveis.',
    visible: true,
  },
  {
    title: 'Simulados',
    location: '/simulado',
    icon: Exam,
    description: 'Teste seus conhecimentos com simulados.',
    visible: false,
  },
  {
    title: 'Simulados',
    location: '/simulados',
    icon: Exam,
    description: 'Teste seus conhecimentos com simulados.',
    visible: false,
  },
  {
    title: 'Simulados',
    location: '/simulados/novo',
    icon: Exam,
    description: 'Teste seus conhecimentos com simulados.',
    visible: true,
  },
  /*   {
    title: 'Química no dia-a-dia',
    location: '/quimica-no-dia-a-dia',
    icon: Exam,
    description: 'A química presente no nosso cotidiano.',
    visible: true
  }, */
  {
    title: 'Conquistas',
    location: '/conquistas',
    icon: Trophy,
    description: 'Veja suas conquistas e desafios.',
    visible: true,
  },
  {
    title: 'Comunidade',
    location: '/comunidade',
    icon: Chats,
    description: 'Um fórum para tirar dúvidas e compartilhar conhecimento.',
    visible: true,
  },
  {
    title: 'Calendário',
    location: '/calendario',
    icon: Calendar,
    description: 'Acompanhe datas e crie lembretes importantes.',
    visible: true,
  },
];

export default menuLinks;
